import { render, staticRenderFns } from "./AddressByHuman.vue?vue&type=template&id=06da0a4c&"
import script from "./AddressByHuman.vue?vue&type=script&lang=js&"
export * from "./AddressByHuman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddressByHuman.vue"
export default component.exports